const REBUILD_REQUIRED = 'administrator_rebuild_required';

export const localStoreNeedsAdministratorRecovery = (status) => (
  status?.state === 'unavailable' && status?.recovery === REBUILD_REQUIRED
);

export const localStoreCanRetry = (status) => (
  status?.state === 'unavailable' && !localStoreNeedsAdministratorRecovery(status)
);

export const localStoreRecoveryDetail = (status) => {
  if (status?.reason === 'local_process_stop_unconfirmed') {
    return 'Stopping offline services could not be confirmed. Replacement is paused until stopping is confirmed. Online work remains available; an administrator can retry.';
  }
  if (localStoreNeedsAdministratorRecovery(status)) {
    return 'This computer’s protected offline key cannot be opened. Online work remains available, but offline storage requires administrator recovery. Unsynchronized work may exist inside the inaccessible store.';
  }
  return 'Offline storage could not be opened securely. Online work remains available. This may be temporary, so retry before considering recovery.';
};
